import React, { useState, FormEvent, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import Layout from "../components/layouts/Layout";
import PasswordField from "../components/PasswordField";
import TextField from "../components/TextField";
import ROUTES from "../setup/routes";
import { useAuth } from "../hooks/useAuth";
import { StateContext } from "../store/context";

import Logo from "../static/logo.png";
import ForgotPasswordBG from "../static/forgot-password-bg.jpg";
import ErrorBoundary from "../components/ErrorBoundary";
import { useFetchApi } from "../hooks/useFetchApi";
import Loader from "../components/Loader";
import AuthScreenLayout from "../components/authScreens/authScreenLayout";

export const _h = "18";

const ForgotPassword: React.FC = (): React.ReactElement => {
  const { t } = useTranslation();
  const params = useParams();
  console.log("params", params);
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [passwordReset, setPasswordReset] = useState(false);

  const { execute, response, loading } = useFetchApi(
    "/api/forgot-password",
    {},
    "POST"
  );

  const goToLogin = (e: any) => {
    e.preventDefault();
    navigate(ROUTES.LOGIN);
  };

  const handleForgotPassword = async (e: any) => {
    e.preventDefault();
    execute({ username });
  };

  const handleChange = (e: FormEvent<HTMLInputElement>): void => {
    const id = e.currentTarget.id;
    const value = e.currentTarget.value;

    setUsername(value);
  };

  useEffect(() => {
    console.log("response", response);
    if (response && !loading) {
      const { status } = response;
      if (status === "success") {
        setPasswordReset(true);
      }
    }
  }, [response, loading]);

  useEffect(() => {
    if (params && params.token) {
    }
  }, [params]);

  const ForgotPasswordSuccess = () => {
    return (
      <div className="mt-10">
        <p className="text-neutral mb-6 font-dm text-center">
          Reset password instructions have been sent to your email address.
        </p>
        <div className="text-center">
          <button
            className="bg-primary text-white hover:bg-primary-hover px-4 py-2 rounded-md inline-block"
            onClick={goToLogin}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  };

  const handleGoBack = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <Layout preLogin>
      <AuthScreenLayout>
        <div className=" w-full md:w-10/12  p-8 flex flex-col justify-center items-center">
          <div className="w-full ">
            <div className="flex items-center justify-center mb-4">
              <img src={Logo} className="flex h-24 p-3" />
            </div>
            {!passwordReset ? (
              <>
                {" "}
                <h1 className="text-2xl font-bold text-gray-900 mb-2 font-dm">
                  Forget Password
                </h1>
                <p className="text-gray-600 mb-8 font-dm">
                  Please Enter Your Email to reset the password
                </p>
                <ErrorBoundary />
                <div>
                  <ErrorBoundary />
                  <form onSubmit={handleForgotPassword} className="space-y-6">
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-6 text-gray-900 font-dm"
                      >
                        Email address or username
                      </label>
                      <div className="mt-2">
                        <TextField
                          full
                          id="username"
                          autoComplete="username"
                          required
                          value={username}
                          onChange={handleChange}
                          className=" bg-transparent border-[#CCCCCC] rounded-[8px] placeholder:text-[#CCCCCC] font-dm  h-[44px]"
                        />
                      </div>
                    </div>

                    <div className="flex md:flex-row flex-col gap-3">
                      <Button
                        variant="secondary"
                        type="button"
                        onClick={handleGoBack}
                        full
                      >
                        Back to login
                      </Button>
                      <Button
                        type="submit"
                        full
                        disabled={!username || loading}
                      >
                        Reset Password
                      </Button>
                    </div>
                  </form>
                </div>
              </>
            ) : (
              <ForgotPasswordSuccess />
            )}

            <p className="text-center text-sm text-gray-500 mt-8">
              ©2025 Valueit. All rights reserved.
            </p>
          </div>
        </div>
      </AuthScreenLayout>
    </Layout>
  );
};

export default ForgotPassword;
